import { render, staticRenderFns } from "./ChooseServiceType.vue?vue&type=template&id=3393f0a5&scoped=true"
import script from "./ChooseServiceType.vue?vue&type=script&lang=js"
export * from "./ChooseServiceType.vue?vue&type=script&lang=js"
import style0 from "./ChooseServiceType.vue?vue&type=style&index=0&id=3393f0a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3393f0a5",
  null
  
)

export default component.exports